export const OAUTH_NEXT_COOKIE_NAME = "hyred_oauth_next";
export const OAUTH_NEXT_COOKIE_MAX_AGE_SECONDS = 900;
